import { SxProps, Theme } from '@mui/material';

export const categoryCardStyleContainerSx: SxProps<Theme> = (theme) => ({
	position: 'relative',
	padding: '10px',
	width: '260px',
	height: '345px',
	display: 'flex',
	flexDirection: 'column',
	boxShadow: theme.shadows[1],
	transition: 'transform 1600ms ease',
	'&:hover': {
		cursor: 'pointer',
		transform: 'scale(1.05)',
	},
});

export const categoryCardMediaImageSx: SxProps<Theme> = {
	width: '100%',
	height: '100%',
};

export const categoryCardLinkSx: SxProps<Theme> = {
	width: '100%',
	height: '100%',
};

export const categoryCardMediaImageBoxSx: SxProps = {
	width: '100%',
	height: '100%',
};

export const categoryCardStackNameSx: SxProps = {
	position: 'absolute',
	bottom: '20px',
	left: '50%',
	transform: 'translateX(-50%)',
	width: 'fit-content',
};

export const categoryCardNameSx: SxProps<Theme> = (theme) => ({
	color: theme.palette.primary.contrastText,
	textDecoration: 'underline',
	padding: '6px 10px 6px 10px',
	backgroundColor: theme.palette.grey[500],
	borderRadius: '3px',
	boxShadow: '0 3px 6px rgba(0, 0, 0, 0.16)',
});
